import React, { useEffect, useMemo, useState } from 'react'
import '../styles/payment.css'
import { useNavigate } from 'react-router-dom'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { FiCheck } from 'react-icons/fi'
import * as action from '../store/actions'
import * as authAction from '../store/authAction'
import { clearNeedsPayment } from '../utils/signupDraft'
import AuthBg from '../img/EBD428F1-DF85-4FFB-80F5-1E799D849F44.GIF'

const PLANS = [
  {
    id: 'plan1',
    name: 'Kids',
    price: 10,
    blurb: 'Safer viewing for younger accounts.',
    perks: ['No ads', '5 hours a month', 'Kids content only', '5-day money back']
  },
  {
    id: 'plan2',
    name: 'New World',
    price: 20,
    blurb: 'Everyday watching plus light posting.',
    perks: ['No ads', '10 hours a month', 'All regular content', 'Post 1 video a week', '5-day money back']
  },
  {
    id: 'plan3',
    name: 'Full',
    price: 30,
    blurb: 'Unlimited time and premium access.',
    perks: ['No ads', '24 hours a month', 'Premium content', 'Post 7 videos a week', '10-day money back']
  }
]

const Payment = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [planId, setPlanId] = useState('plan2')
  const [paid, setPaid] = useState(false)
  const [error, setError] = useState('')
  const plan = PLANS.find(item => item.id === planId) || PLANS[1]
  const paypalOptions = useMemo(() => ({
    'client-id': 'AWG4i_sEd3Y-lY-17B6nA91fkGw-gAUL7jyyMLxpDTcLWhrMX7KILsnLfe5qUNa770CEfhGxQrAryHV7',
    currency: 'USD',
    intent: 'capture'
  }), [])

  useEffect(() => {
    const userData = localStorage.getItem('userdata')
    if (!userData) return undefined
    try {
      const { id, pid } = JSON.parse(userData)
      dispatch(authAction.auth(id, pid))
    } catch (err) {}
    return undefined
  }, [dispatch])

  const leave = () => {
    clearNeedsPayment()
    navigate('/', { replace: true })
  }

  const finishPaid = async () => {
    try {
      await dispatch(action.make_sub(plan.id))
    } catch (err) {}
    setPaid(true)
    clearNeedsPayment()
    window.setTimeout(() => navigate('/', { replace: true }), 900)
  }

  return (
    <section className="paymentPage">
      <Helmet>
        <title>Choose a plan</title>
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <img className="paymentBg" src={AuthBg} alt="" />

      <div className="paymentShell">
        <header className="paymentIntro">
          <p>Welcome in</p>
          <h1>Pick a plan to start</h1>
          <span>You can skip and watch with ads anytime.</span>
        </header>

        <div className="paymentPlans">
          {PLANS.map(item => (
            <button
              key={item.id}
              type="button"
              className={`paymentPlan${planId === item.id ? ' isOn' : ''}`}
              onClick={() => { setPlanId(item.id); setError('') }}
            >
              <strong>{item.name}</strong>
              <b>${item.price}<small>/mo</small></b>
              <em>{item.blurb}</em>
              <ul>
                {item.perks.map(perk => (
                  <li key={perk}><FiCheck /> {perk}</li>
                ))}
              </ul>
            </button>
          ))}
        </div>

        <div className="paymentCheckout">
          {paid ? (
            <p className="paymentDone">Payment received. Taking you in…</p>
          ) : (
            <>
              <p className="paymentTotal">Pay ${plan.price} for {plan.name}</p>
              {error ? <p className="paymentError">{error}</p> : null}
              <PayPalScriptProvider options={paypalOptions}>
                <PayPalButtons
                  style={{ layout: 'vertical', color: 'white', shape: 'pill', label: 'pay' }}
                  forceReRender={[plan.price, plan.id]}
                  createOrder={(data, actions) => actions.order.create({
                    purchase_units: [{ amount: { currency_code: 'USD', value: String(plan.price) } }]
                  })}
                  onApprove={(data, actions) => actions.order.capture().then(() => finishPaid())}
                  onError={() => setError('PayPal could not complete this payment')}
                />
              </PayPalScriptProvider>
              <button type="button" className="paymentSkip" onClick={leave}>
                Skip, watch with ads
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default Payment
